import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ApiError } from "src/api/axiosClient/types";
import { RootState } from "src/store";
import { GetKeywordsParams, Keyword } from "../types";
import { KeywordsState } from "./types";

const initialState: KeywordsState = {
  loading: {
    getList: false,
    create: false,
    update: false,
    delete: false,
  },
  filter: {
    companyId: "",
    offset: 0,
    limit: 25,
    page: 0,
  },
  list: null,
  error: null,
};

const keywordsSlice = createSlice({
  name: "keywords",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<Partial<Record<keyof KeywordsState["loading"], boolean>>>) => {
      state.loading = { ...state.loading, ...action.payload };
    },
    setFilter(state, action: PayloadAction<Partial<GetKeywordsParams>>) {
      state.filter = {
        ...state.filter,
        ...action.payload,
      };
    },
    setList: (
      state,
      action: PayloadAction<{
        items: Keyword[];
        count: number;
      }>
    ) => {
      state.list = action.payload;
    },
    setError: (state, action: PayloadAction<ApiError>) => {
      state.error = action.payload;
    },
    resetList: (state) => {
      state.filter = initialState.filter;
      state.list = initialState.list;
    },
    resetError: (state) => {
      state.error = initialState.error;
    },
    resetSlice: () => {
      initialState;
    },
  },
});

export const isKeywordsLoading = (state: RootState) => state.keywords.loading;

export const getKeywords = (state: RootState) => state.keywords.list;

export const isKeywordsError = (state: RootState) => state.keywords.error;

export const { setLoading, setFilter, setList, setError, resetList, resetError, resetSlice } = keywordsSlice.actions;

export const keywordsReducer = keywordsSlice.reducer;
